export const SOCKET_ENDPOINT = 'http://localhost:8000';



// WEBPACK FOOTER //
// ./src/constants/socket_endpoint.ts